<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Category</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Category</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="card" id="department-add">
        <div class="overlay" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <div class="card-header">
          <h3 class="card-title" v-if="!is_edit">Create</h3>
          <h3 class="card-title" v-if="is_edit">Edit</h3>
          <div class="card-tools">
            <router-link class="btn btn-info" :to="{ name: 'Categories' }"
              ><i class="fas fa-list"></i> List
            </router-link>
          </div>
        </div>
        <div class="card-body">
          <el-tabs>
            <el-tab-pane label="Category">
              <form
                @submit.prevent="handleSubmission()"
                method="POST"
                novalidate
              >
                <div class="form-group required">
                  <label class="control-label">Parent Category</label>
                  <br />
                  <el-select
                    v-model="inputs.parent_category_id"
                    v-validate="'required'"
                    name="parent_category"
                    placeholder="Select"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in parent_categories"
                      :key="item.value"
                      v-bind:class="{
                        'has-error': errors.has('parent_category'),
                      }"
                      v-validate="'required'"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div
                    class="help text-danger"
                    v-show="errors.has('parent_category')"
                  >
                    {{ errors.first("parent_category") }}
                  </div>
                </div>

                <div class="form-group required">
                  <label for="name" class="control-label">Name (English)</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    v-bind:class="{ 'has-error': errors.has('name') }"
                    v-validate="'required'"
                    v-model="inputs.name"
                    @change="slug($event)"
                    class="form-control name"
                    placeholder="Name (English)"
                  />
                  <div class="help text-danger" v-show="errors.has('name')">
                    {{ errors.first("name") }}
                  </div>
                </div>

                <div class="form-group">
                  <label for="name" class="control-label">Name (Bangla)</label>
                  <input
                    type="text"
                    id="name_bn"
                    name="name_bn"
                    v-bind:class="{ 'has-error': errors.has('name_bn') }"
                    v-model="inputs.name_bn"
                    class="form-control name_bn"
                    placeholder="Name (Bangla)"
                  />
                </div>

                <div class="form-group required">
                  <label class="control-label" for="slug">Slug</label>
                  <input
                    type="text"
                    id="slug"
                    name="slug"
                    v-bind:class="{ 'has-error': errors.has('slug') }"
                    v-validate="'required'"
                    v-model="inputs.slug"
                    class="form-control"
                    placeholder="Slug"
                  />
                  <div class="help text-danger" v-show="errors.has('slug')">
                    {{ errors.first("slug") }}
                  </div>
                </div>

                <div class="form-group required">
                  <label class="control-label">Organization</label>
                  <multiselect
                    name="Organization"
                    v-model="inputs.organization_id"
                    :options="organizations.map((org) => org.id)"
                    :custom-label="
                      (opt) => organizations.find((x) => x.id == opt).org_name
                    "
                    placeholder="Pick Organization"
                    :searchable="true"
                    :multiple="false"
                    v-bind:class="{ 'has-error': errors.has('Organization') }"
                    v-validate="'required'"
                    class="organization"
                  >
                  </multiselect>
                  <div
                    class="help text-danger"
                    v-show="errors.has('Organization')"
                  >
                    {{ errors.first("Organization") }}
                  </div>
                </div>
                <div class="form-group required">
                  <label for="desc" class="control-label"
                    >Description (English)</label
                  >
                  <textarea
                    id="desc"
                    name="desc"
                    v-model="inputs.desc"
                    v-bind:class="{ 'has-error': errors.has('desc') }"
                    class="form-control"
                    placeholder="Description"
                    v-validate="'required'"
                    rows="3"
                  ></textarea>
                  <div class="help text-danger" v-show="errors.has('desc')">
                    {{ errors.first("desc") }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="desc" class="control-label"
                    >Description (Bangla)</label
                  >
                  <textarea
                    id="desc_bn"
                    name="desc_bn"
                    v-model="inputs.desc_bn"
                    v-bind:class="{ 'has-error': errors.has('desc_bn') }"
                    class="form-control"
                    placeholder="Display name (Bangla)"
                    v-validate="'required'"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group required">
                  <label for="thumbnail" class="control-label">Thumbnail</label>
                  <div class="row">
                    <div class="col-4">
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            name="thumbnail"
                            class="form-control-file"
                            id="thumbnail"
                            v-bind:class="{
                              'has-error': errors.has('thumbnail'),
                            }"
                            @change="selectFile"
                            accept="image/png, image/jpeg, image/jpg"
                          />
                          <label class="custom-file-label" for="thumbnail">
                            {{ inputs.thumbnail_name }}
                          </label>
                          <div
                            class="help text-danger"
                            v-show="errors.has('thumbnail')"
                          >
                            {{ errors.first("thumbnail") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-8">
                      <img
                        alt="preview image"
                        v-if="temp_logo"
                        v-bind:src="temp_logo"
                        width="100"
                        height="100"
                        class="img-thumbnail"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group required">
                  <label class="control-label">Is active</label>
                  <div class="form-group">
                    <el-select
                      v-model="inputs.status"
                      placeholder="Select"
                      v-validate="'required'"
                    >
                      <el-option
                        v-for="item in [
                          { value: 'active', label: 'Active' },
                          { value: 'inactive', label: 'Inactive' },
                        ]"
                        :key="item.value"
                        v-bind:class="{ 'has-error': errors.has('status') }"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="is_popular" class="control-label"
                    >Is Popular?</label
                  >
                  <br />
                  <el-switch
                    v-bind:class="{ 'has-error': errors.has('is_popular') }"
                    v-model="inputs.is_popular"
                    id="is_popular"
                    name="is_popular"
                    :active-value="1"
                    :inactive-value="0"
                    :width="50"
                  >
                  </el-switch>
                  <div
                    class="help text-danger"
                    v-show="errors.has('is_popular')"
                  >
                    {{ errors.first("is_popular") }}
                  </div>
                </div>
                <div>
                  <button type="submit" v-if="!is_edit" class="btn btn-primary">
                    Submit
                  </button>
                  <button type="submit" v-if="is_edit" class="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </el-tab-pane>
            <el-tab-pane label="SEO Meta" v-if="is_edit">
              <CategorySEOMetaForm :meta="meta"></CategorySEOMetaForm>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CategorySEOMetaForm from "@/views/ProductManagement/Category/CategorySEOMetaForm.vue";
import { CategoryAPI, CommonAPI } from "@/services/api";

export default {
  name: "CategoryForm",
  metaInfo: {
    title: "Category Form | Dotlines",
  },
  data: () => ({
    inputs: {
      slug: "",
      thumbnail_name: "Choose a file",
    },
    organizations: [],
    parent_categories: [],
    temp_logo: "",
    is_loading: false,
    is_edit: false,
    params: {},
    meta: {
      seoable_id: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
    },
  }),
  methods: {
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.is_edit) {
            CategoryAPI.update(this.params.id, this.inputs)
              .then((response) => {
                this.$router.push({ name: "Categories" });
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                this.$toaster.error(error.data.message);
                this.$setErrorsFromResponse(error.data);
              });
          } else {
            CategoryAPI.store(this.inputs)
              .then((response) => {
                this.$router.push({ name: "Categories" });
                this.$toaster.success(response.message);
              })
              .catch((err) => {
                if (err.data.status === 500) {
                  this.$toaster.error(err.data.message);
                } else if (err.data.status === 422) {
                  this.$toaster.error(err.data.message);
                  this.$setErrorsFromResponse(err.data);
                }
              });
          }
        }
      });
    },

    getOrganizations() {
      CommonAPI.getAllOrganizations().then((organizations) => {
        this.organizations = organizations;
      });
    },

    async show(id) {
      this.asset_get_url = this.API_ASSET_UPLOAD_URL;
      await CategoryAPI.show(id).then((item) => {
        this.inputs = item;
        if (!_.isNull(item.meta_data)) {
          this.meta = item.meta_data;
        } else {
          this.meta.seoable_id = id;
        }
        this.temp_logo = this.asset_get_url + "/" + this.inputs.thumbnail;
        this.$delete(this.inputs, "thumbnail");
      });
    },

    selectFile(event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.inputs.thumbnail = reader.result;
        this.temp_logo = reader.result;
        this.$set(this.inputs, "thumbnail_name", event.target.files[0].name);
      };
    },

    getParentCategory() {
      CategoryAPI.getAllParentCategories().then((parent_categories) => {
        this.parent_categories = parent_categories.map(function (each) {
          return {
            value: each.id,
            label: each.title,
          };
        });
      });
    },

    slug(event) {
      let title = event.target.value;
      this.inputs.slug = title.replace(/\s+/g, "-").toLowerCase();
      console.log("this.inputs.slug:: ", this.inputs.slug);
    },
    async initialLoad() {
      this.is_loading = true;
      await this.getOrganizations();
      await this.getParentCategory();
      this.params = this.$route.params;
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.show(this.params.id);
      }
      this.is_loading = false;
    },
  },
  mounted() {
    this.initialLoad();
  },
  components: {
    CategorySEOMetaForm,
  },
};
</script>
